import React, { useState, useEffect } from 'react';
import './SideNavbar.css';
import Modal from '../Modal/Modal';
import { Link, useLocation, useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Tooltip from '@material-ui/core/Tooltip';
import {
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';
import { findAllByDisplayValue } from '@testing-library/react';
import InfoImage from '../../Images/info.svg';
import devInfo from '../../Images/devinfo.svg';
import devhub from '../../Images/devhub.svg';
import helpcenter from '../../Images/helpcenter.svg';
import { handleResetSearchTerm, userLogOut } from '../../Store/User/userAction';
import { useDispatch } from 'react-redux';
import ConfirmDeleteModal from '../Modal/ConfirmDeleteModal';
import ReportModal from '../Modal/ReportModal';
import { resetPreProcessing } from '../../Store/PreProcessing/PreprocessingActions';
import { hideCheckboxes } from '../../Store/Queues/queuesAction';

const SideMenu = ({ module }) => {
  console.log(module, 'module');
  const location = useLocation();
  const history = useHistory();
  const [state, setState] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showUserInfoModal, setShowUserInfoModal] = useState(false);
  const [info, setInfo] = useState(false);
  const [reportModalShow, setReportModalShow] = useState(false);

  const dispatch = useDispatch();

  const handleClick = () => {
    setShowModal(true);
    handleCloseUserInfoModal();
  };
  useEffect(() => {
    const urlElements = window.location;
    var url = new URL(urlElements);
    let token = url.searchParams.get('token');

    if (token) {
      setState(true);
      sessionStorage.setItem('name', 'Jyothi Prakash');
    }
    console.log(token, 'token');
  }, []);
  const handleClose = () => {
    setShowModal(false);
    handleCloseUserInfoModal();
  };
  const handleShowUserInfoModal = () => {
    setShowUserInfoModal(true);
  };
  const handleCloseUserInfoModal = () => {
    setShowUserInfoModal(false);
  };

  const openInfoModal = () => {
    setInfo(true);
  };
  const closeInfoModal = () => {
    setInfo(false);
  };
  const logout = async() => {
    const res = await userLogOut();
    if(res){
    sessionStorage.clear();
    window.location.href = '/';
    }
  };
  const { pathname } = location;
  const splitLocation = pathname.split('/');
  const user_name = sessionStorage.getItem('name')
    ? sessionStorage.getItem('name').split('@')[0]
    : 'Jyothi Prakash';

  console.log('/client/client-upload', splitLocation);
  return (
    <div>
      <nav id='sidebar' className='activexyz'>
        {module === 'processor' ? (
          <ul id='sideNavTop' className='list-unstyled components'>
            <li id='logoLi'>
              <div className='activexyz logo_ind'></div>
            </li>
            <Tooltip title='Dashboard' placement='right' id='tooltipContainer'>
              <li>
                <div
                  // to='/processordashboard'

                  onClick={() => {
                    dispatch(handleResetSearchTerm());
                    if (pathname === '/processordashboard') return;
                    if (pathname === '/editdocument') {
                      dispatch(resetPreProcessing());
                      sessionStorage.setItem('activeIndex', 1);
                      history.push({
                        pathname: '/processordashboard',
                      });
                    } else {
                      if (sessionStorage.getItem('activeIndex') == 2) {
                        sessionStorage.setItem('activeIndex', 2);
                      } else {
                        sessionStorage.setItem('activeIndex', 0);
                      }
                      history.push({
                        pathname: '/processordashboard',
                      });
                    }
                  }}
                  style={{ textDecoration: 'none' }}
                >
                  <div
                    data-tip='dash_document'
                    id='sideElements1'
                    className={
                      splitLocation[1] === 'processordashboard'
                        ? 'activepage'
                        : ''
                    }
                  >
                    <div className='activexyz dash_document'>
                      <p>Dashboard</p>
                    </div>
                  </div>
                </div>
              </li>
            </Tooltip>
            {/* <Tooltip
              title="EditDocument"
              placement="right"
              id="tooltipContainer"
            >
              <li>
                <Link
                  to='/editdocument'
                  onClick={() => dispatch(handleResetSearchTerm())}
                  style={{ textDecoration: 'none' }}
                >
                  <div
                    data-tip='upload_doc'
                    id='sideElements1'
                    className={
                      splitLocation[1] === 'editdocument' ? 'activepage' : ''
                    }
                  >
                    <div className='activexyz upload_doc'>
                      <p>EditDocument</p>
                    </div>
                  </div>
                </Link>
              </li>
            </Tooltip> */}
          </ul>
        ) : module === 'admin' ? (
          <div>
            <ul id='sideNavTop' className='list-unstyled components'>
              <li id='logoLi'>
                <div className='activexyz logo_ind'></div>
              </li>
              <Tooltip title='Queue' placement='right' id='tooltipContainer'>
                <li>
                  <Link
                    onClick={() => {
                      dispatch(handleResetSearchTerm());
                      dispatch(hideCheckboxes(true));
                    }}
                    to='/'
                    style={{ textDecoration: 'none' }}
                  >
                    <div
                      data-tip='Queue'
                      id='sideElements1'
                      className={splitLocation[1] === '' || splitLocation[1] === 'queuesMapProcessors' ? 'activepage' : ''}
                    >
                      <div className='activexyz Queue'>
                        <p> Queue </p>
                      </div>
                    </div>
                  </Link>
                </li>
              </Tooltip>
              <Tooltip title='Processor' placement='right'>
                <li>
                  <Link
                    onClick={() => {
                      dispatch(handleResetSearchTerm());
                      dispatch(hideCheckboxes(true));
                    }}
                    to='/processers'
                    style={{ textDecoration: 'none' }}
                  >
                    <div
                      data-tip='Processor'
                      id='sideElements1'
                      className={
                        splitLocation[1] === 'processers' ? 'activepage' : ''
                      }
                    >
                      <div className='activexyz Processor'>
                        <p> Processor </p>
                      </div>
                    </div>
                  </Link>
                </li>
              </Tooltip>
              <Tooltip title='Document Types' placement='right'>
                <li>
                  <Link
                    onClick={() => {
                      dispatch(handleResetSearchTerm());
                      dispatch(hideCheckboxes(true));
                    }}
                    to='/documents'
                    style={{ textDecoration: 'none' }}
                  >
                    <div
                      data-tip='Document'
                      id='sideElements1'
                      className={
                        splitLocation[1] === 'documents' ? 'activepage' : ''
                      }
                    >
                      <div className='activexyz Document'>
                        <p> Document </p>
                      </div>
                    </div>
                  </Link>
                </li>
              </Tooltip>
              <Tooltip title='Fields' placement='right'>
                <li>
                  <Link
                    onClick={() => {
                      dispatch(handleResetSearchTerm());
                      dispatch(hideCheckboxes(true));
                    }}
                    to='/fields'
                    style={{ textDecoration: 'none' }}
                  >
                    <div
                      data-tip='Fields'
                      id='sideElements1'
                      className={
                        splitLocation[1] === 'fields' ? 'activepage' : ''
                      }
                    >
                      <div className='activexyz Fields'>
                        <p> Fields </p>
                      </div>
                    </div>
                  </Link>
                </li>
              </Tooltip>
              <Tooltip title='Upload ' placement='right' id='tooltipContainer'>
                <li>
                  <Link
                    onClick={() => dispatch(handleResetSearchTerm())}
                    to='/admin-upload'
                    style={{ textDecoration: 'none' }}
                  >
                    <div
                      data-tip='dash_document'
                      id='sideElements1'
                      className={
                        splitLocation[1] === 'admin-upload' ? 'activepage' : ''
                      }
                    >
                      <div className='activexyz upload_document'>
                        <p>Dashboard</p>
                      </div>
                    </div>
                  </Link>
                </li>
              </Tooltip>

              <Tooltip
                title='Open Cases '
                placement='right'
                id='tooltipContainer'
              >
                <li>
                  <Link
                    onClick={() => dispatch(handleResetSearchTerm())}
                    to='/open-cases'
                    style={{ textDecoration: 'none' }}
                  >
                    <div
                      data-tip='dash_document'
                      id='sideElements1'
                      className={
                        splitLocation[1] === 'open-cases' ? 'activepage' : ''
                      }
                    >
                      <div className='activexyz open-cases'>
                        <p>Open Cases Dashboard</p>
                      </div>
                    </div>
                  </Link>
                </li>
              </Tooltip>
              <Tooltip
                title='MIS Dashboard '
                placement='right'
                id='tooltipContainer'
              >
                <li>
                  <Link
                    onClick={() => dispatch(handleResetSearchTerm())}
                    to='/mis-dashboard'
                    style={{ textDecoration: 'none' }}
                  >
                    <div
                      data-tip='dash_document'
                      id='sideElements1'
                      className={
                        splitLocation[1] === 'mis-dashboard' ? 'activepage' : ''
                      }
                    >
                      <div className='activexyz dash_document'>
                        <p>MIS Dashboard</p>
                      </div>
                    </div>
                  </Link>
                </li>
              </Tooltip>
            </ul>
          </div>
        ) : (
          <ul id='sideNavTop' className='list-unstyled components'>
            <li id='logoLi'>
              <div className='activexyz logo_ind'></div>
            </li>
            <Tooltip title='Upload ' placement='right' id='tooltipContainer'>
              <li>
                <Link
                  onClick={() => dispatch(handleResetSearchTerm())}
                  to='/client/client-upload'
                  style={{ textDecoration: 'none' }}
                >
                  <div
                    data-tip='dash_document'
                    id='sideElements1'
                    className={
                      splitLocation[2] === 'client-upload' ? 'activepage' : ''
                    }
                  >
                    <div className='activexyz upload_document'>
                      <p>Upload</p>
                    </div>
                  </div>
                </Link>
              </li>
            </Tooltip>
            <Tooltip
              title='Open Cases '
              placement='right'
              id='tooltipContainer'
            >
              <li>
                <Link
                  onClick={() => dispatch(handleResetSearchTerm())}
                  to='/client/open-cases'
                  style={{ textDecoration: 'none' }}
                >
                  <div
                    data-tip='dash_document'
                    id='sideElements1'
                    className={
                      splitLocation[2] === 'open-cases' ? 'activepage' : ''
                    }
                  >
                    <div className='activexyz open-cases'>
                      <p>Open Cases Dashboard</p>
                    </div>
                  </div>
                </Link>
              </li>
            </Tooltip>
          </ul>
        )}
        <ul id='sideNavBottom' className='list-unstyled components'>
          <li>
            <div onClick={openInfoModal} style={{ cursor: 'pointer' }}>
              <img src={InfoImage} alt='infoimage' />
            </div>
          </li>
          {/* info modal */}
          <Dialog
            className='custom-dialog-container custom-dialog-container-info'
            onClose={closeInfoModal}
            aria-labelledby='simple-dialog-title'
            open={info}
          >
            <DialogTitle>
              <div
                onClick={() => {
                  setReportModalShow(true);
                  closeInfoModal(false);
                }}
                className='devinfo'
              >
                <img src={devInfo} alt='devinfo' />
                <div>Report a Problem</div>
              </div>
              {/* <div className='devinfo'>
                <img src={helpcenter} alt='helpcenter' />
                <div>Help Center</div>
              </div> */}
              <div className='devinfo'>
                <img src={devhub} alt='devhub' />
                <div>Developer Hub</div>
              </div>
            </DialogTitle>
          </Dialog>

          <li>
            <div className='Logout' onClick={handleShowUserInfoModal}>
              {user_name[0].toUpperCase()}
              <p> Logout </p>
            </div>
          </li>
          <Dialog
            className='custom-dialog-container'
            onClose={handleCloseUserInfoModal}
            aria-labelledby='simple-dialog-title'
            open={showUserInfoModal}
          >
            <DialogTitle>
              <div className='dialogLogo'>{user_name[0].toUpperCase()}</div>
            </DialogTitle>
            <DialogTitle>{user_name}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {sessionStorage.getItem('name')}
              </DialogContentText>
            </DialogContent>
            <hr
              style={{
                height: '1px',
                width: '100%',
                color: 'black',
                margin: 0,
                padding: 0,
              }}
            />
            <DialogActions>
              <Button
                onClick={handleClick}
                variant='text'
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                }}
              >
                Logout
              </Button>
            </DialogActions>
            <div className='dialogFooter'>
              <a href='https://in-d.ai/privacy-policy/' target='_blank'>
                Privacy Policy
              </a>
              <a href='https://in-d.ai/terms-of-use/' target='_blank'>
                Terms of Use
              </a>
            </div>
          </Dialog>
        </ul>
      </nav>

      {showModal ? (
        <Modal
          handleClick={handleClick}
          handleClose={handleClose}
          name={'Jyothi Prakash'}
          desc={
            'You are logging out of the portal. Are you sure want to proceed? '
          }
          header={'Confirm Logout'}
          modal={showModal}
          logout={logout}
          functionText='Logout'
        />
      ) : (
        ''
      )}
      {reportModalShow && (
        <ReportModal
          handleClick={() => setReportModalShow(true)}
          handleClose={() => setReportModalShow(false)}
          header={'Confirm Logout'}
          modal={reportModalShow}
          open={reportModalShow}
        />
      )}
    </div>
  );
};
export default SideMenu;
